export function AvisEditableListFooterCell() {
  return <th></th>;
}
